const _inputDefaultAttrs = {
  regular: true,
  color: 'primary',
  itemColor: 'primary',
  placeholder: 'Selecione',
  persistentPlaceholder: false,
  borderSelected: true,
}
export const AUTOCOMPLETE_ATTRS = {
  clearable: true,
  ..._inputDefaultAttrs,
}
export const TEXTFIELD_ATTRS = {
  ..._inputDefaultAttrs,
}